import { createApp } from '@app/adapters/create-app'

import BeamerChangelogBanner from './../sections/changelog/components/beamer-changelog-banner.vue'
import BeamerBridge from './../sections/changelog/beamer-bridge'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='changelog-banner']").each(function () {
    const beamerChangelogBannerApp = createApp(BeamerChangelogBanner)

    beamerChangelogBannerApp.use(
      BeamerBridge(this.dataset.changelogApiKey, this.dataset.changelogSegment)
    )

    beamerChangelogBannerApp.mount(this)
  })
})
